<template>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M4.85294 6.26562H3V21.199C3 22.3723 3.83382 23.3323 4.85294 23.3323H17.8235V21.199H4.85294V6.26562ZM19.1464 2H8.02872C7.0096 2 6.17578 2.96 6.17578 4.13333V16.9333C6.17578 18.1067 7.0096 19.0667 8.02872 19.0667H19.1464C20.1655 19.0667 20.9993 18.1067 20.9993 16.9333V4.13333C20.9993 2.96 20.1655 2 19.1464 2ZM18.8849 11.6021H9.35547V9.46875H18.8849V11.6021ZM14.6496 15.8677H9.35547V13.7344H14.6496V15.8677ZM18.8849 7.33646H9.35547V5.20312H18.8849V7.33646Z"
  />
</template>
